module.exports = __webpack_public_path__ + "static/media/Andy - Pastels.5c01a16a.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/Andy - Pastels.jpg
 ** module id = 383
 ** module chunks = 0
 **/